import { Position, PositionRange } from '../../types'

export function fixVisibleRange(
  [visibleStart, visibleEnd]: PositionRange,
  [removeStart, removeEnd]: PositionRange,
  length: Position,
): PositionRange {
  // --------VISIBLE--
  // -REMOVE----------
  if (removeEnd < visibleStart) {
    const shift = removeEnd - removeStart
    return [visibleStart - shift, visibleEnd - shift]
  }

  // -----VISIBLE--
  // -REMOVE-------
  if (removeEnd <= visibleStart && removeEnd < visibleEnd) {
    const shift = visibleStart - removeStart
    return [visibleStart - shift, visibleEnd - shift]
  }

  // --VISIBLE--
  // ----REM----
  if (removeStart >= visibleStart && removeEnd <= visibleEnd) {
    return [visibleStart, Math.min(visibleEnd, length)]
  }

  // ----VIS---
  // --REMOVED-
  if (removeStart <= visibleStart && removeEnd >= visibleEnd) {
    const visibleLength = visibleEnd - visibleStart
    const end = Math.min(removeStart + visibleLength, length)
    return [Math.max(end - visibleLength, 0), end]
  }

  // -VISIBLE-----
  // ------REMOVE-
  if (removeStart <= visibleEnd && removeEnd > visibleEnd) {
    return [visibleStart, Math.min(visibleEnd, length)]
  }

  // -VISIBLE--------
  // ---------REMOVE-
  return [visibleStart, visibleEnd]
}
